module.exports = ".com-login {\n  align-items: center;\n  display: flex;\n  min-height: 100vh;\n}"